import React from 'react';

import '@app/scss/pages/main/feedback.scss';
import quote1 from '@image/valueinclusive/quote-left.svg';

export const ClientFeedback: React.FC = () => {
	return (
		<div className="client-feedback">
			<div className="client-feedback__header">
				<h1
					className="font-family_primary font-weight_bold text-size_hard-large"
				>
					<span className="text-uppercase text-header__primary">What our</span>
					<span className="font-family_decorative font-weight_regular text-header__highlight"> Clients</span>
					<span className="text-uppercase text-header__primary"> are</span>
					<span className="font-family_decorative font-weight_regular text-header__highlight"> Saying</span>
				</h1>
				<img
					src={quote1}
					alt=""
				/>
			</div>
			<div className="feedback__container">
				<div
					className="trustpilot-widget"
					data-locale="en-US"
					data-template-id="53aa8912dec7e10d38f59f36"
					data-businessunit-id="6037f8ef3217ab0001f8e69e"
					data-style-height="300px"
					data-style-width="100%"
					data-theme="light"
					data-tags="vip"
					data-stars="4,5"
					data-review-languages="en"
					data-font-family="Fira Sans"
					data-text-color="#090e2c"
				>
					<a
						href="https://www.trustpilot.com/review/onlinevacationcenter.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						Trustpilot Reviews
					</a>
				</div>
			</div>
		</div>
	);
};
